const wl = process.env.WHITELABEL;

const whitelabel = {
	name: wl.name,
	shortName: wl.shortName,
	logoWide: wl.logoWide,
	logoSquare: wl.logoSquare,
	loginIllustration: wl.loginIllustration,
	mapboxStyle: wl.mapboxStyle,
	supportURL: wl.supportURL,
	hardwareSetupSupportURL: wl.hardwareSetupSupportURL,
	palette: wl.palette,
	mappedin: wl.mappedin,
};

export default whitelabel;
